<div class="card" [ngClass]="class" *transloco="let t; read: 'ime.common.unit-conversions'">
  <div class="card-body">
    <div class="d-flex">
      <h5 class="d-inline my-auto">{{t('Unit Conversions')}}</h5>
      <help-button *transloco="let h" [key]="h('help.ime.common.units')"></help-button>
      <button type="button" class="btn btn-sm btn-outline-primary ms-auto" *ngIf="!readonly" (click)="add()">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
        {{t('Add')}}
      </button>
    </div>
    <table class="table table-borderless mt-1" *ngIf="container.UnitConversions?.length">
      <thead class="table-light">
      <tr>
        <th scope="col" class="w-25">{{t('Base')}}</th>
        <th scope="col" class="w-25">{{t('Target')}}</th>
        <th scope="col">{{t('Factor')}}</th>
        <th scope="col">{{t('Comment')}}</th>
        <th scope="col" *ngIf="!readonly"></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let unitConversion of container.UnitConversions">
        <td>
          <mes-web-unit-select name="base-{{unitConversion.Id}}" [items$]="unitService.getAll$" [entityId]="unitConversion.BaseUnitId" [readonly]="readonly"
                               (entityIdChange)="unitConversion.BaseUnitId = $event; changed.emit(false)"></mes-web-unit-select>
        </td>
        <td>
          <mes-web-unit-select name="target-{{unitConversion.Id}}" [items$]="unitService.getAll$" [entityId]="unitConversion.UnitId" [readonly]="readonly"
                               (entityIdChange)="unitConversion.UnitId = $event; changed.emit(false)"></mes-web-unit-select>
        </td>
        <td>
          <input class="form-control form-control-sm" name="ConversionFactor-{{unitConversion.Id}}" [decimalPlaces]="17" [(mesNumberInput)]="unitConversion.ConversionFactor" (input)="changed.emit(false)" [readOnly]="readonly">
        </td>
        <td>
          <textarea name="comment-{{unitConversion.Id}}" class="form-control" [(ngModel)]="unitConversion.Comment" (ngModelChange)="changed.emit(false)" [readOnly]="readonly"></textarea>
        </td>
        <td *ngIf="!readonly">
          <button type="button" class="btn btn-sm btn-outline-danger" (click)="remove(unitConversion)">
            <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#trash"></svg>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
